





















































import Vue from "vue";
import { Advertisement } from "@/interfaces/advertisement";
import { MessageBox } from "@/interfaces/messagebox";
import MessageBoxList from "@/components/MessageBoxList.vue";
import { Advertiser } from "@/interfaces/advertiser";
import _ from "lodash";
import AppFormLogicMixin from "@/plugins/AppFormLogicMixin";
//   validatePath="/api/adv/message_boxes/validate"
// savePath="/api/adv/message_boxes"

export default Vue.extend({
  components: { MessageBoxList },
  mixins: [AppFormLogicMixin],
  methods: {
    decoratePostData(postData: MessageBox) {
      if (this.advertisement) {
        postData.advertisement = this.advertisement["@id"];
      } else {
        delete postData.advertisement;
      }

      return postData;
    },
    onComplete() {
      this.$router.push({
        name: "AdvertiserContactComplete"
      });
    }
  },
  computed: {
    _() {
      return _;
    },
    targetAdvertisementId() {
      return this.$route.query.advertisement;
    },
    rawPostData(): MessageBox {
      return this.messageBox;
    },
    validateUrl(): string {
      return "/api/adv/message_boxes/validate";
    },
    execUrl(): string {
      return "/api/adv/message_boxes";
    }
  },
  data() {
    return {
      advertisement: {} as Advertisement,
      messageBox: {} as MessageBox,
      advertiser: {} as Advertiser
    };
  },
  async mounted() {
    if (this.targetAdvertisementId) {
      this.advertisement = await this.$store.dispatch("get", [
        "/api/adv/posts/" + this.targetAdvertisementId
      ]);
    }
    this.advertiser = await this.$store.dispatch("get", [
      this.$store.getters.my().advertiser
    ]);

    // this.isLoading = false;
  }
});
